import * as Yup from 'yup';

export const messageLogTabFiltersSchema = () =>
  Yup.object({
    from: Yup.date().nullable(),
    propertyUid: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    sentVia: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    status: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    to: Yup.date().nullable(),
  });

export type MessageLogTabFiltersSchemaType = Yup.InferType<
  ReturnType<typeof messageLogTabFiltersSchema>
>;

export const getFormDefaultValues = (): MessageLogTabFiltersSchemaType => {
  return {
    from: null,
    propertyUid: [],
    sentVia: [],
    status: [],
    to: null,
  };
};
